import chevronLeft from '@iconify/icons-ant-design/left-outline';
import React from 'react';
import * as help from './help-page-header-styles';
export function ChevronLeft() {
  return <help.StyledChevron size="14" icon={chevronLeft} />;
}

export function HelpPageLink(props) {
  return (
    <help.HelpCenterLinkWrapper onClick={props.onClick}>
      <ChevronLeft />
      <help.StyledLink appearance="link" active>
        {props.content}
      </help.StyledLink>
    </help.HelpCenterLinkWrapper>
  );
}

export function SearchInput(props) {
  return (
    <help.StyledInputGroup inside>
      <help.StyledInputGroup.Addon>
        <help.StyledSearchIcon />
      </help.StyledInputGroup.Addon>
      <help.StyledInput
        onKeyUp={props.onKeyUp}
        placeholder={props.placeholder}
      />
    </help.StyledInputGroup>
  );
}

export function SearchButton(props) {
  return (
    <help.StyledButton onClick={props.onClick}>
      <help.StyledButtonTitle content={props.buttonContent} />
    </help.StyledButton>
  );
}

export function SearchBarWithButtonAndTitle(props) {
  return (
    <help.SearchTitleWrapper>
      <help.RentalscapeTitle />
      <help.SearchWrapper>
        <SearchInput
          onKeyUp={props.inputOnKeyUp}
          placeholder={props.inputPlaceholder}
        />
        <SearchButton
          buttonContent={props.buttonContent}
          onClick={props.onButtonClick}
        />
      </help.SearchWrapper>
    </help.SearchTitleWrapper>
  );
}

export function ContactIconButton(props) {
  return (
    <help.StyledInvisibleButton title={props.title} onClick={props.onClick}>
      <help.StyledContactIcon />
    </help.StyledInvisibleButton>
  );
}

export function PrintIconButton(props) {
  return (
    <help.StyledInvisibleButton title={props.title} onClick={props.onClick}>
      <help.StyledPrintIcon />
    </help.StyledInvisibleButton>
  );
}

export function TopRowIconsWrapper(props) {
  return (
    <help.StyledTopRowIconsWrapper>
      <ContactIconButton
        title={props.contactTitle}
        onClick={props.contactOnClick}
      />
      <PrintIconButton title={props.printTitle} onClick={props.printOnClick} />
    </help.StyledTopRowIconsWrapper>
  );
}

export function Background({ children }) {
  return (
    <help.BackgroundColor>
      <help.BackgroundSVG />
      {children}
    </help.BackgroundColor>
  );
}

export function HelpPageHeader(props) {
  return (
    <Background>
      <help.Wrapper>
        {props.showHelpCenterLink && (
          <HelpPageLink
            content={props.helpCenterLinkContent}
            onClick={props.helpCenterLinkOnClick}
          />
        )}
        <TopRowIconsWrapper
          contactTitle={props.contactIconTitle}
          contactOnClick={props.contactOnClick}
          printTitle={props.printIconTitle}
          printOnClick={props.printOnClick}
        />
        <SearchBarWithButtonAndTitle
          inputPlaceholder={props.inputPlaceholder}
          inputOnKeyUp={props.onSubmitEnter}
          buttonContent={props.buttonContent}
          onButtonClick={props.onButtonClick}
        />
      </help.Wrapper>
    </Background>
  );
}
